import React from 'react';
import ReactDOM from 'react-dom';
import _path from 'ramda/src/path';
import FeaturedListingContainer from './FeaturedListingContainer';
import ProfileFeedsContainer from './ProfileFeedsContainer';
import ProfileSideBar from '../Common/ProfileSideBar/ProfileSideBar';
import { MessageProvider } from '../Common/Message';


const websiteId = window.sID;
ReactDOM.render(
	<React.StrictMode>
		<FeaturedListingContainer websiteId={websiteId} />
	</React.StrictMode>,
	document.querySelector('#FeaturedListings')
);

if (document.querySelector('#ProfileFeedsContainer')) {
	ReactDOM.render(
		<React.StrictMode>
			<MessageProvider>
				<ProfileFeedsContainer websiteId={websiteId} />
			</MessageProvider>
		</React.StrictMode>,
		document.querySelector('#ProfileFeedsContainer')
	);
}

if (document.querySelector('#ProfileSideBar')) {
	ReactDOM.render(
		<React.StrictMode>
			<MessageProvider>
				<ProfileSideBar />
			</MessageProvider>
		</React.StrictMode>,
		document.querySelector('#ProfileSideBar')
	);
}
